export default {
  filters: {
    currencyFormat: n => (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(n)),
  }
}
